import "./iui.scss";
import {
  postPrescriptionTemplate,
  postPatientReport,
  fetchPatientDetailsUuid,
  coupleIdChecker,
  postAppointment,
} from "../../Redux/Thunk/Actions";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import headerimage from "../../assets/images/ascas.svg";
import { useState } from "react";
import Headers from "../../Components/Header/Headers";
import { LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import { DemoItem } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { PrescriptionFooter } from "../../Components/Prescription Footer/PrescriptionFooter";

export default function LutealSupport(props) {
  const [valueChange, setvalueChange] = useState({});
  const [show, setshow] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [patientOne_UUId, setPatientOne_UUId] = useState("");
  const patientId = useSelector((state) => state.counter.patientid);
  const [appointmentData, setAppointmentData] = useState({
    p_uhid: "",
    name: "",
    date: "",
    time: "",
    status: "Not Visited",
    notes: "",
    patient_id: "",
  });

  const [rows, setRows] = useState([
    { date: "", cycleDay: "", right: "", left: "", et: "", drugsAdvice: "" },
  ]);

  const handleAddRow = () => {
    setRows([
      ...rows,
      { date: "", cycleDay: "", right: "", left: "", et: "", drugsAdvice: "" },
    ]);
  };
  const handleChangeid = (e) => {
    var text = e.target.value;

    if (e.target.name === "patientId1") {
      if (/^(ASCAS|VDASCAS)\d+$/i.test((e.target.value || "").trim())) {
        const fetchData = async () => {
          const payload = {
            p_uhid: e.target.value,
          };
          props.loaderchange("true");
          const addPatient = fetchPatientDetailsUuid(payload);
          const response = await dispatch(addPatient);
          if (response.payload?.status?.code === 200) {
            const data = response.payload.data.data[0];
            const namePat =
              data?.titles + " " + data?.first_name + " " + data?.last_name;
            if (e.target.name === "patientId1") {
              setPatientOne_UUId(data?.id);
              setvalueChange({
                ...valueChange,
                patientName1: namePat,
                age1: data?.age,
                gender1: data?.gender,
                patientId1: text,
              });
            }
            props.loaderchange("false");
          } else {
            props.loaderchange("false");
            props.popupalert("true");
            props.popuptext("Network went wrong, Please try after some time.");
            setTimeout(() => {
              props.popupalert("false");
            }, 2000);
          }
          return;
        };

        fetchData();
      } else {
        if (e.target.name === "patientId1") {
          setvalueChange({
            ...valueChange,
            patientId1: e.target.value,
          });
        }
      }
    } else {
      console.log("Going in");
      setvalueChange({ ...valueChange, [e.target.name]: e.target.value });
      if (e.target.name === "nextappointment") {
        const dateTime = e.target.value.split("T");
        setAppointmentData({
          ...appointmentData,
          date: dateTime[0],
          time: dateTime[1],
          p_uhid: props.patientsData.p_uhid,
          name: `${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`,
          status: "Not Visited",
          notes: "Booking Visit",
          patient_id: patientId,
        });
      }
    }
  };
  const handleChange = (index, e) => {
    const { name, value } = e.target;
    const newRows = [...rows];
    newRows[index][name] = value;
    setRows(newRows);
  };
  const handleRemoveRow = (index) => {
    const newRows = rows.filter((row, i) => i !== index);
    setRows(newRows);
  };

  const renderInput = (name, type = "text") => (
    <>
      <input
        className={`createTime ${show ? "hide" : "show"}`}
        name={name}
        type={type}
        onChange={(e) => handleChangeid(e, name)}
      />
      <span className={`input ${!show ? "hide" : "show"}`}>
        &nbsp;{valueChange[name]}
      </span>
    </>
  );

  const renderReportfield = (name, value, options = {}) => {
    const { styleSec = {}, styleLabel = {}, styleSpan = {} } = options;

    return (
      <>
        <section
          style={{ ...styleSec, margin: "0 10px 10px 10px", display: "flex" }}
        >
          <label
            style={{
              ...styleLabel,
              fontWeight: "600",
              marginRight: "5px",
              width: "max-content",
            }}
          >
            {name}
          </label>
          <span style={styleSpan}>{value}</span>
        </section>
      </>
    );
  };
  const renderTableTD = (value) => {
    return (
      <td style={{ border: "1px solid black", textAlign: "center" }}>
        {value}
      </td>
    );
  };
  const renderTableTH = (value) => {
    return (
      <th style={{ border: "1px solid black", textAlign: "center" }}>
        {value}
      </th>
    );
  };

  const [medRows, setMedRows] = useState([
    {
      sno: "",
      medications: "",
      dosage: "",
      frequency: "",
      route: "",
      days: "",
    },
  ]);

  const medRowAdd = () => {
    setMedRows([
      ...medRows,
      {
        sno: "",
        medications: "",
        dosage: "",
        frequency: "",
        route: "",
        days: "",
      },
    ]);
  };
  const medRowRemove = (i) => {
    let newPast = medRows.filter((row, ind) => i !== ind);
    setMedRows(newPast);
  };

  const handleMedValue = (ind, e) => {
    const { name, value } = e.target;
    const newRows = [...medRows];
    newRows[ind][name] = value;
    setMedRows(newRows);
  };
  const handleMuiTimeChange = (e, name) => {
    let hours = e.$H,
      mins = e.$m,
      ampm = "AM";
    let temMin = e.$m;
    temMin < 10 ? (mins = "0" + temMin) : (mins = temMin);
    if (e.$H >= 12) {
      if (e.$H === 12) {
        hours = 12;
        ampm = "PM";
      } else {
        let temHour = e.$H - 12;
        temHour < 10 ? (hours = "0" + temHour) : (hours = temHour);
        ampm = "PM";
      }
    } else if (e.$H === 0) {
      hours = 12;
      ampm = "AM";
    } else {
      let temHour = e.$H;
      temHour < 10 ? (hours = "0" + temHour) : (hours = temHour);
      ampm = "AM";
    }

    setvalueChange({ ...valueChange, [name]: `${hours}-${mins}-${ampm}` });
  };
  const renderMuiTime = (name) => {
    return (
      <div id="addmissionDate">
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DemoItem>
            <TimePicker onChange={(e) => handleMuiTimeChange(e, name)} />
          </DemoItem>
        </LocalizationProvider>
      </div>
    );
  };
  const handlesubmit = () => {
    props.loaderchange("true");
    try {
      if (
        props.patientsData.id !== "" &&
        props.patientsData.p_uhid !== "" &&
        /^(ASCAS|VDASCAS)\d+$/i.test((props.patientsData.p_uhid || '').trim())
      ) {
        setshow(true);
        setTimeout(async () => {
          const htmlPayload = document.getElementById(
            "iuiReportGenerateWarp"
          ).innerHTML;

          const payload = {
            payload: {
              prescription_template: htmlPayload,
              patient_id: patientId,
              description: "",
              template_type: "IUI",
            },
          };
          const createNewAppointment = async () => {
            console.log(appointmentData);
            await dispatch(postAppointment(appointmentData));
          };
          createNewAppointment();
          props.loaderchange(true);
          const patentDetails = postPrescriptionTemplate(payload);
          const response = await dispatch(patentDetails);
          if (response?.payload?.status?.code === 200) {
            props.loaderchange(false);
            navigate("/PatientView");
            Swal.fire({
              title: "Successful.",
              text: "Record added successful.",
              icon: "success",
              showConfirmButton: false,
              timer: 1500,
            });
            props.loaderchange("false");
          } else {
            props.loaderchange("false");
            props.popupalert("true");
            props.popuptext("Network went wrong, Please try after some time.");
            // props.popuptext(response?.status?.message);
            setTimeout(() => {
              props.popupalert("false");
            }, 2000);
          }
        }, 3000);
      } else {
        Swal.fire({
          title: "Error.",
          text: "Please enter valid patient id.",
          icon: "error",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };
  return (
    <div id="Iui">
      <div className="Iui">
        <div
          className=""
          style={{ width: "100%", display: "block" }}
          id="patientInfo1"
        >
          <div style={{ width: "100%" }}>
            <img
              className="header_image"
              // src={"https://s3.amazonaws.com/likodi.com/ascslogo.png"}
              src={headerimage}
              style={{
                // width: "100%", height: "25vh", maxHeight: show ? "100px" : "400px"

                width: "100%",
                margin: "0 auto",
              }}
            ></img>
          </div>
          {/* <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "center",
              gap: "3px",
              backgroundColor: "#f7f7f7 ",
              borderRadius: "6px",
              padding: "16px 8px 16px 8px",
              gap: "3px"

            }}
          >
            <div style={{ display: "flex", gap: "16px", alignItems: "center" }}>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "125px 16px 250px",
                  alignItems: "center ",
                }}
              >
                <span style={{ fontWeight: 600 }}>Patient ID</span>
                <span style={{ fontWeight: 600 }}>: </span>
                <input
                  type="text"
                  className={`createTime ${show ? "hide" : "show"}`}
                  value={valueChange.patientId1}
                  onChange={(e) => handleChangeid(e)}
                  name="patientId1"
                  style={{
                    border: "1px solid #ddd",
                    outline: "none",
                    padding: "10px",
                  }}
                />
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{valueChange.patientId1}
                </span>
              </div>
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "125px 16px 250px",
                alignItems: "center ",
              }}
            >
              <span style={{ fontWeight: 600 }}>Patient Name</span>
              <span style={{ fontWeight: 600 }}>: </span>
              <input
                type="text"
                className={`createTime ${show ? "hide" : "show"}`}
                onChange={(e) => handleChangeid(e)}
                value={valueChange.patientName1}
                name="patientName1"
                style={{
                  border: "1px solid #ddd",
                  outline: "none",
                  padding: "10px",
                  color: "#000",
                }}
              />
              <span
                className={`input ${!show ? "hide" : "show"}`}
                style={{ width: "100%" }}
              >
                &nbsp;{valueChange.patientName1}
              </span>
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "16px",
              }}
            >
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "125px 16px 250px",
                  alignItems: "center ",
                }}
              >
                <span style={{ fontWeight: 600 }}>Gender</span>
                <span style={{ fontWeight: 600 }}>: </span>
                <select
                  className={`createTime ${show ? "hide" : "show"}`}
                  onChange={(e) => handleChangeid(e)}
                  value={valueChange.gender1}
                  name="gender1"
                  style={{
                    border: "1px solid #ddd",
                    outline: "none",
                    padding: "10px",
                    backgroundColor: "white",
                  }}
                >
                  <option value="" disabled selected>
                    Select Gender
                  </option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Others">Others</option>
                  <option value="Decline to State">Decline to State</option>
                </select>
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{valueChange.gender1}
                </span>
              </div>
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "125px 16px 250px",
                alignItems: "center ",
              }}
            >
              <span style={{ fontWeight: 600 }}>Age</span>
              <span style={{ fontWeight: 600 }}>: </span>
              <input
                type="text"
                className={`createTime ${show ? "hide" : "show"}`}
                onChange={(e) => handleChangeid(e)}
                value={valueChange.age1}
                name="age1"
                style={{
                  border: "1px solid #ddd",
                  outline: "none",
                  padding: "10px",
                }}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{valueChange.age1}
              </span>
            </div>
          </div> */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "center",
              gap: "3px",
              backgroundColor: "#f7f7f7 ",
              borderRadius: "6px",
              padding: "16px 8px 16px 8px",
              gap: "3px",
            }}
          >
            <div style={{ display: "flex", gap: "16px", alignItems: "center" }}>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "125px 16px 250px",
                  alignItems: "center ",
                }}
              >
                <span style={{ fontWeight: 600 }}>Patient ID</span>
                <span style={{ fontWeight: 600 }}>: </span>
                <input
                  type="text"
                  className={`createTime ${show ? "hide" : "show"}`}
                  value={props.patientsData.p_uhid}
                  onChange={(e) => handleChange(e)}
                  name="patientId"
                  style={{
                    border: "1px solid #ddd",
                    outline: "none",
                    padding: "10px",
                  }}
                />
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{props.patientsData.p_uhid}
                </span>
              </div>
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "125px 16px 250px",
                alignItems: "center ",
              }}
            >
              <span style={{ fontWeight: 600 }}>Patient Name</span>
              <span style={{ fontWeight: 600 }}>: </span>
              <input
                type="text"
                className={`createTime ${show ? "hide" : "show"}`}
                onChange={(e) => handleChange(e)}
                value={`${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`}
                name="patientName"
                style={{
                  border: "1px solid #ddd",
                  outline: "none",
                  padding: "10px",
                  color: "#000",
                }}
              />
              <span
                className={`input ${!show ? "hide" : "show"}`}
                style={{ width: "100%" }}
              >
                &nbsp;
                {`${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`}
              </span>
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "16px",
              }}
            >
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "125px 16px 250px",
                  alignItems: "center ",
                }}
              >
                <span style={{ fontWeight: 600 }}>Gender</span>
                <span style={{ fontWeight: 600 }}>: </span>
                <select
                  className={`createTime ${show ? "hide" : "show"}`}
                  onChange={(e) => handleChange(e)}
                  value={props.patientsData.gender}
                  name="gender"
                  style={{
                    border: "1px solid #ddd",
                    outline: "none",
                    padding: "10px",
                    backgroundColor: "white",
                  }}
                >
                  <option value={props.patientsData.gender} selected>
                    {props.patientsData.gender}
                  </option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Others">Others</option>
                  <option value="Decline to State">Decline to State</option>
                </select>
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{props.patientsData.gender}
                </span>
              </div>
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "125px 16px 250px",
                alignItems: "center ",
              }}
            >
              <span style={{ fontWeight: 600 }}>Age</span>
              <span style={{ fontWeight: 600 }}>: </span>
              <input
                type="text"
                className={`createTime ${show ? "hide" : "show"}`}
                onChange={(e) => handleChange(e)}
                value={props.patientsData.age}
                name="age1"
                style={{
                  border: "1px solid #ddd",
                  outline: "none",
                  padding: "10px",
                }}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{props.patientsData.age}
              </span>
            </div>
          </div>
        </div>
        <div className="detail">
          <h2>CYCLE NO</h2>
          <p>
            D2/3 Scan:Uterus {renderInput("uterus")}
            RT.AFC {renderInput("rtafc")}
            LT.AFC {renderInput("ltafc")}
            AMH {renderInput("amh")} ng/ml
          </p>
          <p>
            Tubal Patency:
            <select
              name="tubalPatency"
              onChange={(e) => handleChangeid(e, "tubalPatency")}
            >
              <option value="" selected disabled>
                Please Select
              </option>
              <option value="done">done</option>
              <option value="not done">not done</option>
            </select>
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{valueChange["tubalPatency"]}
            </span>
          </p>
          <p>
            Method:
            <select name="method" onChange={(e) => handleChangeid(e, "method")}>
              <option value="" selected disabled>
                Please Select
              </option>
              <option value="DHL">DHL</option>
              <option value="HSG">HSG</option>
              <option value="SSG">SSG</option>
            </select>
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{valueChange["method"]}
            </span>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;RT tube -{" "}
            {renderInput("rttube")} LT tube - {renderInput("lttube")}
          </p>
          <p>
            MEDICAL CONDITION: WIFE
            <select
              name="medicalConditionWife"
              onChange={(e) => handleChangeid(e, "medicalConditionWife")}
            >
              <option value="" selected disabled>
                Please Select
              </option>
              <option value="DM">DM</option>
              <option value="HT">HT</option>
              <option value="THYROID">THYROID</option>
            </select>
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{valueChange["medicalConditionWife"]}
            </span>
            HUSBAND
            <select
              name="medicalConditionHusband"
              onChange={(e) => handleChangeid(e, "medicalConditionHusband")}
            >
              <option value="" selected disabled>
                Please Select
              </option>
              <option value="DM">DM</option>
              <option value="HT">HT</option>
              <option value="THYROID">THYROID</option>
            </select>
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{valueChange["medicalConditionHusband"]}
            </span>
          </p>{" "}
          <p>Female</p>
        </div>
        <table className="table_1" border="1px" cellSpacing="0px">
          <tbody>
            <tr>
              <th>MEDICATIONS</th>
              <th>DOSAGE</th>
              <th>ROUTE</th>
              <th>FREQUENCY</th>
              <th>TIMING</th>
              <th>DAYS</th>
            </tr>
            <tr>
              <td>LETROZ / LETROSOUL</td>
              <td>{renderInput("letroz_dosage")}</td>
              <td>{renderInput("letroz_route")}</td>
              <td>{renderInput("letroz_frequency")}</td>
              <td>{renderInput("letroz_timing")}</td>
              <td>{renderInput("letroz_days")}</td>
            </tr>
            <tr>
              <td>C. FOLVISTA</td>
              <td>{renderInput("folvista_dosage")}</td>
              <td>{renderInput("folvista_route")}</td>
              <td>{renderInput("folvista_frequency")}</td>
              <td>{renderInput("folvista_timing")}</td>
              <td>{renderInput("folvista_days")}</td>
            </tr>
            <tr>
              <td>CYSTOP OD</td>
              <td>{renderInput("cystop_dosage")}</td>
              <td>{renderInput("cystop_route")}</td>
              <td>{renderInput("cystop_frequency")}</td>
              <td>{renderInput("cystop_timing")}</td>
              <td>{renderInput("cystop_days")}</td>
            </tr>
            <tr>
              <td>Inj. OVUTAS HP / PERSINAL HP</td>
              <td>{renderInput("ovutas_dosage")}</td>
              <td>{renderInput("ovutas_route")}</td>
              <td>{renderInput("ovutas_frequency")}</td>
              <td>{renderInput("ovutas_timing")}</td>
              <td>{renderInput("ovutas_days")}</td>
            </tr>
            <tr>
              <td>T. GLYCOMET SR</td>
              <td>{renderInput("glycomet_dosage")}</td>
              <td>{renderInput("glycomet_route")}</td>
              <td>{renderInput("glycomet_frequency")}</td>
              <td>{renderInput("glycomet_timing")}</td>
              <td>{renderInput("glycomet_days")}</td>
            </tr>
            <tr>
              <td>T. CO Q</td>
              <td>{renderInput("coq_dosage")}</td>
              <td>{renderInput("coq_route")}</td>
              <td>{renderInput("coq_frequency")}</td>
              <td>{renderInput("coq_timing")}</td>
              <td>{renderInput("coq_days")}</td>
            </tr>
          </tbody>
        </table>
        <div className="detail">
          <p>Male</p>
        </div>
        <table className="table_1" border="1px" cellSpacing="0px">
          <tbody>
            <tr>
              <th>MEDICATIONS</th>
              <th>DOSAGE</th>
              <th>ROUTE</th>
              <th>FREQUENCY</th>
              <th>TIMING</th>
              <th>DAYS</th>
            </tr>
            <tr>
              <td>C. Evion</td>
              <td>{renderInput("evion_dosage")}</td>
              <td>{renderInput("evion_route")}</td>
              <td>{renderInput("evion_frequency")}</td>
              <td>{renderInput("evion_timing")}</td>
              <td>{renderInput("evion_days")}</td>
            </tr>
            <tr>
              <td>T. CO Q</td>
              <td>{renderInput("male_coq_dosage")}</td>
              <td>{renderInput("male_coq_route")}</td>
              <td>{renderInput("male_coq_frequency")}</td>
              <td>{renderInput("male_coq_timing")}</td>
              <td>{renderInput("male_coq_days")}</td>
            </tr>
            <tr>
              <td>TAB. QUATACARE M</td>
              <td>{renderInput("quatacare_dosage")}</td>
              <td>{renderInput("quatacare_route")}</td>
              <td>{renderInput("quatacare_frequency")}</td>
              <td>{renderInput("quatacare_timing")}</td>
              <td>{renderInput("quatacare_days")}</td>
            </tr>
          </tbody>
        </table>
        <table
          className="table_1"
          border="1px"
          cellSpacing="0px"
          style={{ marginTop: "20px" }}
        >
          <thead>
            <tr>
              <th>DATE</th>
              <th className="drugs">CYCLE DAY</th>
              <th>RIGHT</th>
              <th>LEFT</th>
              <th>ET(mm)</th>
              <th className="drugs">DRUGS/ADVICE</th>
              <th>ACTIONS</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row, index) => (
              <tr key={index}>
                <td>
                  <input
                    type="date"
                    className={`createTime ${show ? "hide" : "show"}`}
                    name="date"
                    value={row.date}
                    onChange={(e) => handleChange(index, e)}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{row.date}
                  </span>
                </td>
                <td>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    name="cycleDay"
                    value={row.cycleDay}
                    onChange={(e) => handleChange(index, e)}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{row.cycleDay}
                  </span>
                </td>
                <td>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    name="right"
                    value={row.right}
                    onChange={(e) => handleChange(index, e)}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{row.right}
                  </span>
                </td>
                <td>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    name="left"
                    value={row.left}
                    onChange={(e) => handleChange(index, e)}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{row.left}
                  </span>
                </td>
                <td>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    name="et"
                    value={row.et}
                    onChange={(e) => handleChange(index, e)}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{row.et}
                  </span>
                </td>
                <td>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    name="drugsAdvice"
                    value={row.drugsAdvice}
                    onChange={(e) => handleChange(index, e)}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{row.drugsAdvice}
                  </span>
                </td>
                <td>
                  {index == 0 && (
                    <button
                      className={`${show ? "hide" : "show"}`}
                      onClick={(e) => handleAddRow(index)}
                    >
                      +
                    </button>
                  )}
                  {index > 0 && (
                    <button
                      className={`${show ? "hide" : "show"}`}
                      onClick={() => handleRemoveRow(index)}
                    >
                      -
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="bulletin">
          <ol>
            <li>
              <div style={{ display: "flex" }}>
                IUI done date: {renderInput("iuidonedate", "date")}
                Time: {renderMuiTime("time")}
              </div>
            </li>
            <li>
              Follicle:
              <select
                name="follicle"
                onChange={(e) => handleChangeid(e, "follicle")}
              >
                <option value="" selected disabled>
                  Please Select
                </option>
                <option value="Ruptured">Ruptured</option>
                <option value="Not ruptured">Not ruptured</option>
                <option value="Collapsed">Collapsed</option>
              </select>
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{valueChange["follicle"]}
              </span>
            </li>
            <li>
              IUI:
              <select name="iui" onChange={(e) => handleChangeid(e, "iui")}>
                <option value="" selected disabled>
                  Please Select
                </option>
                <option value="Easy">Easy</option>
                <option value="difficult">difficult</option>
              </select>
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{valueChange["iui"]}
              </span>
            </li>
            <li>
              Witnessed by: {renderInput("witnessedby")}
              Androtech: {renderInput("androtech")}
              Staff Nurse: {renderInput("staffnurse")}
            </li>
            <li>
              Consent -
              <select
                name="consent"
                onChange={(e) => handleChangeid(e, "consent")}
              >
                <option value="" selected disabled>
                  Please Select
                </option>
                <option value="Taken">Taken</option>
                <option value="Not taken">Not taken</option>
              </select>
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{valueChange["consent"]}
              </span>
            </li>
          </ol>
        </div>
        <table className="table_1" border="1px" cellSpacing="0px">
          <tbody>
            <tr>
              <th>SI No.</th>
              <th>MEDICATIONS</th>
              <th>DOSAGE</th>
              <th>FREQUENCY</th>
              <th>ROUTE</th>
              <th>DAYS</th>
              <th>Actions</th>
            </tr>
            {medRows.map((_, i) => (
              <tr key={i}>
                <td>{i + 1}</td>
                <td>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    name="medications"
                    onChange={(e) => handleMedValue(i, e)}
                  />
                </td>
                <td>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    name="dosage"
                    onChange={(e) => handleMedValue(i, e)}
                  />
                </td>
                <td>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    name="frequency"
                    onChange={(e) => handleMedValue(i, e)}
                  />
                </td>
                <td>
                  {/* {renderInput(``)} */}
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    name="route"
                    onChange={(e) => handleMedValue(i, e)}
                  />
                </td>
                <td>
                  {/* {renderInput(``)} */}
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    name="days"
                    onChange={(e) => handleMedValue(i, e)}
                  />
                </td>
                <td>
                  {i === 0 && <button onClick={(e) => medRowAdd()}>+</button>}
                  {i !== 0 && (
                    <button onClick={(e) => medRowRemove(i)}>-</button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <br />
        <div className="detail">
          <p>Keep the injections in the fridge door/milk tray. Do not freeze</p>
          <p>
            You can have intercourse during IUI cycle frequently and maintain 1
            day abstinence after final injection day.
            <br />
            Frequent intercourse improves success rates
          </p>
          <p>If you have any issues in giving sperm please inform before IUI</p>
          <p>
            You can take the injection at 6am if IUI is planned in the evening
            or at 8-9 pm if morning IUI is planned
          </p>
          <p>
            You will have the scheduled IUI at the time 36-40 hours from
            trigger. Egg may not always be ruptured
          </p>
          <p>Please take the medications correctly after IUI</p>
          <p>Pregnancy test on {renderInput("pregnancydate", "date")}</p>
        </div>
      </div>
      <p style={{ fontWeight: "600" }}>
        NEXT APPOINTMENT -{" "}
        <input
          name="nextappointment"
          onChange={handleChangeid}
          type="datetime-local"
          // type="date"
        />
      </p>
      <div className={`Footer ${show ? "hide" : "show"}`}>
        <button onClick={handlesubmit} className="Button_Create">
          Add Report
        </button>
      </div>
      <div id="iuiReportGenerate">
        <div id="iuiReportGenerateWarp">
          <Headers />
          <p class="Dani"></p>
          <div
            className="patient"
            style={{
              border: "1px solid black",
              borderRadius: "10px",
              marginBottom: "10px",
            }}
          >
            <div
              className="nameToAgeContainer"
              style={{ display: "flex", marginBottom: "10px" }}
            >
              {renderReportfield(
                "Patient Name :",
                `${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`
              )}
              {renderReportfield("Patient ID :", props.patientsData.p_uhid)}
              {renderReportfield("Gender :", props.patientsData.gender)}
              {renderReportfield("Age :", props.patientsData.age)}
            </div>
          </div>

          <div style={{ display: "flex", marginTop: "10px" }}>
            <h4 style={{ fontWeight: 600, marginRight: "5px" }}>Cycle No</h4>
          </div>
          <div style={{ display: "flex", marginTop: "10px" }}>
            {renderReportfield("D2/3 Scan:Uterus :", valueChange.uterus)}
            {renderReportfield("RT.AFC :", valueChange.rtafc)}
            {renderReportfield("LT.AFC :", valueChange.ltafc)}
            {renderReportfield("AMH :", valueChange.amh)}ng/ml
          </div>
          <div style={{ display: "flex", marginTop: "10px" }}>
            {renderReportfield("Tubal Patency :", valueChange.tubalPatency)}
            {renderReportfield("Method :", valueChange.method)}
            {renderReportfield("RT tube :", valueChange.rttube)}
            {renderReportfield("LT tube :", valueChange.lttube)}
          </div>
          <div style={{ display: "flex", marginTop: "10px" }}>
            {renderReportfield(
              "Medical Condition Wife",
              valueChange.medicalConditionWife
            )}
            {renderReportfield(
              "Husband Condition Husband:",
              valueChange.medicalConditionHusband
            )}
          </div>
          <div style={{ display: "flex", marginTop: "10px" }}>
            <h4 style={{ fontWeight: 600, marginRight: "5px" }}>Female</h4>
          </div>
          <div>
            <table>
              <thead>
                <tr>
                  {[
                    "MEDICATIONS",
                    "DOSAGE",
                    "ROUTE",
                    "FREQUENCY",
                    "TIMING",
                    "DAYS",
                  ].map((ele) => renderTableTH(ele))}
                </tr>
              </thead>
              <tbody>
                {[...Array(6)].map((_, i) => {
                  const med = [
                    "LETROZ / LETROSOUL",
                    "C. FOLVISTA",
                    "CYSTOP OD",
                    "Inj. OVUTAS HP / PERSINAL HP",
                    "T. GLYCOMET SR",
                    "T. CO Q",
                  ];
                  const val1 = [
                    "letroz_",
                    "folvista_",
                    "cystop_",
                    "ovutas_",
                    "glycomet_",
                    "coq_",
                  ];
                  const val2 = [
                    "dosage",
                    "route",
                    "frequency",
                    "timing",
                    "days",
                  ];
                  return (
                    <tr key={i}>
                      {renderTableTD(med[i])}
                      {val2.map((ele, ind) =>
                        renderTableTD(valueChange[`${val1[i]}${ele}`])
                      )}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div style={{ display: "flex", marginTop: "10px" }}>
            <h4 style={{ fontWeight: 600, marginRight: "5px" }}>Male</h4>
          </div>
          <div style={{ display: "flex", marginTop: "10px" }}>
            <table>
              <thead>
                <tr>
                  {[
                    "MEDICATIONS",
                    "DOSAGE",
                    "ROUTE",
                    "FREQUENCY",
                    "TIMING",
                    "DAYS",
                  ].map((ele) => renderTableTH(ele))}
                </tr>
              </thead>
              <tbody>
                {[...Array(3)].map((_, i) => {
                  const med = ["C. Evion", "T. CO Q", "ITAB. QUATACARE M"];
                  const val1 = ["evion_", "male_coq_", "quatacare_"];
                  const val2 = [
                    "dosage",
                    "route",
                    "frequency",
                    "timing",
                    "days",
                  ];
                  return (
                    <tr key={i}>
                      {renderTableTD(med[i])}
                      {val2.map((ele, ind) =>
                        renderTableTD(valueChange[`${val1[i]}${ele}`])
                      )}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div style={{ display: "flex", marginTop: "10px" }}>
            <table>
              <thead>
                {[
                  "DATE",
                  "CYCLE DAY",
                  "RIGHT",
                  "LEFT",
                  "ET(mm)",
                  "DRUGS/ADVICE",
                ].map((ele) => renderTableTH(ele))}
              </thead>
              <tbody>
                {rows.map((ele, ind) => {
                  return (
                    <tr key={ind}>
                      {renderTableTD(ele.date?.split("-").reverse().join("-"))}
                      {renderTableTD(ele.cycleDay)}
                      {renderTableTD(ele.right)}
                      {renderTableTD(ele.left)}
                      {renderTableTD(ele.et)}
                      {renderTableTD(ele.drugsAdvice)}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div style={{ display: "flex", marginTop: "10px" }}>
            {renderReportfield(
              "1) IUI done date :",
              valueChange.iuidonedate?.split("-").reverse().join("-")
            )}
            {renderReportfield("Time :", valueChange.time)}
          </div>
          <div>
            {renderReportfield("2) Follicle :", valueChange.follicle)}
            {renderReportfield("3) IUI :", valueChange.iui)}
          </div>
          <div style={{ display: "flex", marginTop: "10px" }}>
            {renderReportfield("4) Witnessed by :", valueChange.witnessedby)}
            {renderReportfield(" Androtech :", valueChange.androtech)}
            {renderReportfield(" Staff Nurse :", valueChange.staffnurse)}
          </div>
          <div>{renderReportfield("5) Consent :", valueChange.consent)}</div>
          <div>
            <table>
              <thead>
                {[
                  "S No.",
                  "MEDICATIONS",
                  "DOSAGE",
                  "FREQUENCY",
                  "ROUTE",
                  "DAYS",
                ].map((ele) => renderTableTH(ele))}
              </thead>
              <tbody>
                {medRows.map((ele, ind) => (
                  <tr key={ind}>
                    {renderTableTD(ind + 1)}
                    {renderTableTD(ele.medications)}
                    {renderTableTD(ele.dosage)}
                    {renderTableTD(ele.frequency)}
                    {renderTableTD(ele.route)}
                    {renderTableTD(ele.days)}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div>
            {[
              "Keep the injections in the fridge door/milk tray. Do not freeze",

              "You can have intercourse during IUI cycle frequently and maintain 1 day abstinence after final injection day.",

              "Frequent intercourse improves success rates",

              "If you have any issues in giving sperm please inform before IUI",

              "You can take the injection at 6am if IUI is planned in the evening or at 8-9 pm if morning IUI is planned",

              "You will have the scheduled IUI at the time 36-40 hours from trigger. Egg may not always be ruptured",

              "Please take the medications correctly after IUI",
            ].map((ele, ind) => {
              return (
                <div
                  style={{
                    display: "flex",
                    marginBottom: "10px",
                    marginTop: "10px",
                  }}
                >
                  <span style={{ marginRight: "10px" }}>●</span>
                  <p>{ele}</p>
                </div>
              );
            })}
          </div>
          <div
            style={{ display: "flex", marginBottom: "10px", marginTop: "10px" }}
          >
            <span style={{ marginRight: "10px" }}>●</span>
            <p>Pregnancy test on</p>
            <span style={{ marginLeft: "5px" }}>
              {valueChange.pregnancydate?.split("-").reverse().join("-")}
            </span>
          </div>
          <div style={{ marginTop: "10px" }}>
            {renderReportfield(
              "Next Appointment : ",
              appointmentData.date?.split("-").reverse().join("-")
            )}
          </div>
          <p class="Dani"></p>
        <PrescriptionFooter/>
        </div>
      </div>
    </div>
  );
}
